import React, { useEffect, useState } from "react";
import {
  ThinDropdownWithSearch,
  ThinTextField,
} from "../common/GeneralComponent";
import { fetchData } from "../../utils/functions";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const Education = ({ household_listings = [], DqaApproved, DqaRejected }) => {
  const isDqaApproved = DqaApproved || false;
  const isDqaRejected = DqaRejected || false;
  
  const [selectedEducationLevels, setSelectedEducationLevels] = useState({});
  const [selectedAttendances, setSelectedAttendances] = useState({});
  const [selectedReasons, setSelectedReasons] = useState({});
  const [selectedSchoolQualities, setSelectedSchoolQualities] = useState({});
  const [selectedSchoolTypes, setSelectedSchoolTypes] = useState({});
  const [selectedSchoolDistricts, setSelectedSchoolDistricts] = useState({});
  const [districts, setDistricts] = useState([]);
  const [errors, setErrors] = useState({});

  const [saveAttempted, setSaveAttempted] = useState(false);
  useEffect(() => {
    if (saveAttempted) validateAll();
  });
  const [selectedSchoolTypeOthers, setSelectedSchoolTypeOthers] = useState({});

  // Extract education data from household_listings (age 6+)
  const houseHoldEducation = household_listings
    .filter((member) => {
      const age = parseInt(member.age || 0);
      return age >= 6;
    })
    .map((member) => {
      // Get education data with proper fallbacks
      const educationData = member.HouseholdEducation || {};

      return {
        household_education_id:
          educationData.household_education_id || member.household_listing_id,
        household_listing_id: member.household_listing_id,
        education_level: educationData.education_level,
        school_type: educationData.school_type,
        school_type_other_specify: educationData.school_type_other_specify,
        district_id: educationData.district_id,
        school_location: educationData.district_id,
        location_of_school: educationData.district_id,
        school_attendance: educationData.school_attendance,
        school_quality: educationData.school_quality,
        reason_of_not_attending_school:
          educationData.reason_of_not_attending_school,
        HouseholdListing: {
          household_name: member.household_name,
          age: member.age,
        },
      };
    });

  const attendanceOptions = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  const Reasons = [
    { value: "Far away", label: "Far away" },
    { value: "Costly", label: "Costly" },
    {
      value: "Lack of male/female teachers",
      label: "Lack of male/female teachers",
    },
    { value: "Quality of teaching", label: "Quality of teaching" },
    { value: "School building", label: "School building" },
    { value: "Lack of boundary wall", label: "Lack of boundary wall" },
    {
      value: "Water and sanitation facilities",
      label: "Water and sanitation facilities",
    },
    { value: "Child labor", label: "Child labor" },
    { value: "Others", label: "Others" },
    { value: "Enrolled in Madarsah", label: "Enrolled in Madarsah" },
  ];

  const educationOptions = [
    { value: "None", label: "None" },
    { value: "Pre-school/Katchi", label: "Pre-school/Katchi" },
    { value: "Primary (five years)", label: "Primary (five years)" },
    { value: "Lower Secondary", label: "Lower Secondary" },
    { value: "Upper Secondary", label: "Upper Secondary" },
    { value: "Higher Secondary", label: "Higher Secondary" },
    { value: "Graduate/Above", label: "Graduate/Above" },
  ];

  const schoolTypeOptions = [
    { value: "Government", label: "Government" },
    { value: "Private", label: "Private" },
    { value: "Madrassah", label: "Madrassah" },
    { value: "NGO run school", label: "NGO run school" },
    { value: "Others", label: "Others" },
  ];
  const initialSchoolTypeOthers = {};
  const hasEligibleMembers = houseHoldEducation.length > 0;

  useEffect(() => {
    if (!hasEligibleMembers) {
      return;
    }

    const initialLevels = {};
    const initialAttendances = {};
    const initialReasons = {};
    const initialQualities = {};
    const initialSchoolTypes = {};
    const initialSchoolDistricts = {};

    houseHoldEducation.forEach((member) => {
      const id = member.household_education_id;

      initialLevels[id] = member.education_level || "";
      initialAttendances[id] =
        member.school_attendance !== undefined ? member.school_attendance : 1;
      initialReasons[id] = member.reason_of_not_attending_school || "";
      initialQualities[id] =
        member.school_quality !== undefined ? member.school_quality : 1;
      initialSchoolTypes[id] = member.school_type || "";
      initialSchoolTypeOthers[id] = member.school_type_other_specify || "";

      let districtValue = "";
      const districtFromDb =
        member.district_id ||
        member.school_location ||
        member.location_of_school;
      if (districtFromDb !== null && districtFromDb !== undefined) {
        districtValue = String(districtFromDb);
      }
      initialSchoolDistricts[id] = districtValue;
    });

    setSelectedEducationLevels(initialLevels);
    setSelectedAttendances(initialAttendances);
    setSelectedReasons(initialReasons);
    setSelectedSchoolQualities(initialQualities);
    setSelectedSchoolTypes(initialSchoolTypes);
    setSelectedSchoolTypeOthers(initialSchoolTypeOthers);
    setSelectedSchoolDistricts(initialSchoolDistricts);

    fetchDistricts();
  }, [household_listings]);

  const fetchDistricts = async () => {
    try {
      const response = await fetchData("districts", "GET", null, {}, {});
      setDistricts(response?.data || []);
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  const { id } = useParams();

  const isSchoolAge = (member) => {
    const age = parseInt(member?.HouseholdListing?.age || 0);
    return age >= 6 && age <= 11;
  };

  const validateAll = () => {
    const next = {};
    houseHoldEducation.forEach((member) => {
      const eduId = member.household_education_id;
      const e = {};
      const level = selectedEducationLevels[eduId];
      const att = selectedAttendances[eduId];
      const reason = selectedReasons[eduId];
      const type = selectedSchoolTypes[eduId];
      const qual = selectedSchoolQualities[eduId];
      const schoolDistrict = selectedSchoolDistricts[eduId];

      if (!level) {
        e.education_level = "Education level is Required.";
      }

      // Only validate Type of School and District if level is not 'Non-Educated' or 'None'
      if (level !== "None") {
        if (!type) {
          e.school_type = "Type of school is Required.";
        }

        if (!schoolDistrict) {
          e.district_id = "District of school is Required.";
        }
      }
      if (type === "Others" && !selectedSchoolTypeOthers[eduId]) {
        e.school_type_other_specify = "Please specify the type of school.";
      }

      if (isSchoolAge(member)) {
        if (att !== 0 && att !== 1)
          e.school_attendance = "School attendance is Required.";

        if (att === 0) {
          if (!reason)
            e.reason_of_not_attending_school =
              "Reason for not attending school is Required.";
        }

        if (level && level !== "None" && att === 1) {
          if (qual !== 0 && qual !== 1)
            e.school_quality = "School quality is Required.";
        }
      }

      if (Object.keys(e).length) next[eduId] = e;
    });
    setErrors((prev) =>
      JSON.stringify(prev) === JSON.stringify(next) ? prev : next
    );
    return Object.keys(next).length === 0;
  };

  const processDistrictValue = (value) => {
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      value === "null"
    ) {
      return null;
    }

    if (typeof value === "number") {
      return value;
    }

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed === "" || trimmed === "null") return null;

      const num = Number(trimmed);
      return isNaN(num) ? null : num;
    }

    return null;
  };

  const handleUpdate = async () => {
    setSaveAttempted(true);
    if (!validateAll()) {
      return;
    }

    try {
      const payload = houseHoldEducation.map((member) => {
        const eduId = member.household_education_id;
        const level = selectedEducationLevels[eduId];
        const att = selectedAttendances[eduId];
        const schoolDistrict = selectedSchoolDistricts[eduId];

        const processedDistrictId =
          level === "None" ? null : processDistrictValue(schoolDistrict);

        const isNonEducated = level === "Non-Educated";

        return {
          household_education_id: eduId,
          household_listing_id: member.household_listing_id,
          education_level: level,
          school_attendance: isSchoolAge(member) ? att : null,
          reason_of_not_attending_school:
            isSchoolAge(member) && att === 0 ? selectedReasons[eduId] : null,
          school_quality:
            isSchoolAge(member) && att === 1 && !isNonEducated
              ? selectedSchoolQualities[eduId]
              : null,
          school_type: isNonEducated
            ? null
            : selectedSchoolTypes[eduId] || null,
          school_type_other_specify:
            !isNonEducated && selectedSchoolTypes[eduId] === "Others"
              ? selectedSchoolTypeOthers[eduId]
              : null,
          district_id: isNonEducated ? null : processedDistrictId,
        };
      });

      await fetchData(
        `householdeducation-update/${id}`,
        "PUT",
        { data: payload },
        {},
        {}
      );
      toast.success("All education information updated successfully!");
    } catch (error) {
      console.error("Error updating education info:", error);
      toast.error("Error updating education information.");
    }
  };

  const handleDistrictChange = (eduId, value) => {
    setSelectedSchoolDistricts((prev) => ({
      ...prev,
      [eduId]: value,
    }));
  };

  const handleAttendanceChange = (eduId, value) => {
    setSelectedAttendances((prev) => ({
      ...prev,
      [eduId]: value,
    }));

    if (value === 0) {
      setSelectedSchoolQualities((prev) => ({
        ...prev,
        [eduId]: null,
      }));
    }
    if (value === 1) {
      setSelectedReasons((prev) => ({
        ...prev,
        [eduId]: "",
      }));
    }
  };

  const Err = ({ id, name }) =>
    errors?.[id]?.[name] ? (
      <p className="text-[0.9rem] text-red-600 mt-2">{errors[id][name]}</p>
    ) : null;

  const districtOptions = districts.map((district) => ({
    value: district.district_id,
    label: district.district_name,
  }));

  if (!hasEligibleMembers) {
    return (
      <div>
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-4">
            {isDqaApproved && (
              <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
                Approved from DQA
              </span>
            )}
          </div>
        </div>

        <div className="text-center py-8">
          <p className="text-gray-500 italic text-lg">
            No household members aged 6 or above
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* <div className="flex justify-between items-center mb-4">
      <div className="flex items-center gap-2">
        {isDqaApproved && (
          <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full text-sm font-semibold">
            Approved from DQA
          </span>
        )}
      </div>
    </div> */}
      <div className="flex justify-between items-center mb-3">
        {isDqaApproved && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              Household Education
            </h2>
            <span className="bg-blue-100 text-blue-800 px-1 py-1 rounded-full text-sm font-semibold">
              Approved from DQA
            </span>
          </>
        )}
        {isDqaRejected && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              Household Education
            </h2>

            <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-semibold">
              Rejected from DQA
            </span>
          </>
        )}
      </div>

      {houseHoldEducation.map((member) => {
        const eduId = member.household_education_id;
        const showSchoolFields =
          selectedEducationLevels[eduId] &&
          selectedEducationLevels[eduId] !== "None" &&
          selectedEducationLevels[eduId] !== "Non-Educated";
        const isChildSchoolAge = isSchoolAge(member);
        const isAttendingSchool = selectedAttendances[eduId] === 1;
        const isNotAttendingSchool = selectedAttendances[eduId] === 0;

        return (
          <div
            key={eduId}
            className="mb-4 p-4 border border-gray-200 rounded-lg"
          >
            <h3 className="text-base font-medium text-gray-800 mb-3">
              {member?.HouseholdListing?.household_name || `Member ${eduId}`}
            </h3>

            {/* First row: Age, Education level, School Type */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              {/* Age (read-only display) */}
              <ThinTextField
                label="Age"
                value={member?.HouseholdListing?.age || ""}
                disabled
              />

              {/* Education Level */}
              <div>
                <ThinDropdownWithSearch
                  label="Highest level of school"
                  options={educationOptions}
                  value={selectedEducationLevels[eduId] || ""}
                  onChange={(value) =>
                    setSelectedEducationLevels((prev) => ({
                      ...prev,
                      [eduId]: value,
                    }))
                  }
                  disabled={isDqaApproved || isDqaRejected}
                />
                <Err id={eduId} name="education_level" />
              </div>

              {/* School Type */}
              {showSchoolFields && (
                <div>
                  <ThinDropdownWithSearch
                    label="Type of School"
                    options={schoolTypeOptions}
                    value={selectedSchoolTypes[eduId] || ""}
                    onChange={(value) =>
                      setSelectedSchoolTypes((prev) => ({
                        ...prev,
                        [eduId]: value,
                      }))
                    }
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <Err id={eduId} name="school_type" />
                </div>
              )}
              <div>
                {selectedSchoolTypes[eduId] === "Others" && (
                  <div className="mt-1">
                    <ThinTextField
                      label="Specify School Type"
                      value={selectedSchoolTypeOthers[eduId] || ""}
                      onChange={(e) =>
                        setSelectedSchoolTypeOthers((prev) => ({
                          ...prev,
                          [eduId]: e.target.value,
                        }))
                      }
                      disabled={isDqaApproved || isDqaRejected}
                    />
                    <Err id={eduId} name="school_type_other_specify" />
                  </div>
                )}
              </div>
            </div>

            {/* Second row: District, Attendance, Quality or Reason */}
            {showSchoolFields && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* District of School */}
                <div>
                  <ThinDropdownWithSearch
                    label="District of School"
                    options={districtOptions}
                    value={selectedSchoolDistricts[eduId] || ""}
                    onChange={(value) => handleDistrictChange(eduId, value)}
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <Err id={eduId} name="district_id" />
                </div>

                {/* School Attendance */}
                {isChildSchoolAge ? (
                  <div>
                    <p className="mb-1 text-sm font-medium text-gray-700">
                      School Attendance
                    </p>
                    <div className="flex items-center gap-4">
                      <label className="flex items-center gap-1">
                        <input
                          type="radio"
                          checked={selectedAttendances[eduId] === 1}
                          onChange={() => handleAttendanceChange(eduId, 1)}
                          disabled={isDqaApproved || isDqaRejected}
                        />{" "}
                        Yes
                      </label>
                      <label className="flex items-center gap-1">
                        <input
                          type="radio"
                          checked={selectedAttendances[eduId] === 0}
                          onChange={() => handleAttendanceChange(eduId, 0)}
                          disabled={isDqaApproved || isDqaRejected}
                        />{" "}
                        No
                      </label>
                    </div>
                    <Err id={eduId} name="school_attendance" />
                  </div>
                ) : (
                  <div></div>
                )}

                {/* School Quality or Reason */}
                {isChildSchoolAge && isAttendingSchool ? (
                  <div>
                    <p className="mb-1 text-sm font-medium text-gray-700">
                      School Quality
                    </p>
                    <div className="flex items-center gap-4">
                      <label className="flex items-center gap-1">
                        <input
                          type="radio"
                          checked={selectedSchoolQualities[eduId] === 1}
                          onChange={() =>
                            setSelectedSchoolQualities((prev) => ({
                              ...prev,
                              [eduId]: 1,
                            }))
                          }
                          disabled={isDqaApproved || isDqaRejected}
                        />{" "}
                        Good
                      </label>
                      <label className="flex items-center gap-1">
                        <input
                          type="radio"
                          checked={selectedSchoolQualities[eduId] === 0}
                          onChange={() =>
                            setSelectedSchoolQualities((prev) => ({
                              ...prev,
                              [eduId]: 0,
                            }))
                          }
                          disabled={isDqaApproved || isDqaRejected}
                        />{" "}
                        Poor
                      </label>
                    </div>
                    <Err id={eduId} name="school_quality" />
                  </div>
                ) : isChildSchoolAge && isNotAttendingSchool ? (
                  <div>
                    <ThinDropdownWithSearch
                      label="Reason for not attending school"
                      options={Reasons}
                      value={selectedReasons[eduId] || ""}
                      onChange={(value) =>
                        setSelectedReasons((prev) => ({
                          ...prev,
                          [eduId]: value,
                        }))
                      }
                      disabled={isDqaApproved || isDqaRejected}
                    />
                    <Err id={eduId} name="reason_of_not_attending_school" />
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            )}

            <input
              type="hidden"
              value={member?.household_information_id}
              id="household_listing_id"
            />
          </div>
        );
      })}

      {!isDqaApproved && !isDqaRejected && hasEligibleMembers && (
        <div className="mt-4 flex justify-end">
          <button
            className="bg-teal-600 text-white rounded-lg px-3 py-1.5 hover:bg-teal-700 transition-colors"
            onClick={handleUpdate}
          >
            Update
          </button>
        </div>
      )}
    </div>
  );

};

export default Education;
